import makeStyles from '@mui/styles/makeStyles';

const useMonthlyReportStyles = makeStyles({
  root: {},
  containerMinHeight: {
    minHeight: '1000px',
    backgroundColor: 'red'
  }
});

export default useMonthlyReportStyles;
